export default {
  metaDescription: 'TEFは容器、配管、加熱機器などの製作ソリューションに加え、チューブ交換やシェル取替えを含むメンテナンス・修繕サービスを提供します。',
  pageTitle: 'サービス',
  expertise: {
    title: '当社の強み',
    description:
      '<strong>PT TOKKI ENGINEERING AND FABRICATION</strong>は、インドネシアから世界中のお客様へ高品質な製品と優れたアフターサービスをお届けすることに尽力しています。<strong>溶接圧力容器および板金加工</strong>を専門とする企業として、<strong>石油・ガス、石油化学、製薬、肥料、農薬、発電、熱処理産業</strong>など幅広い産業インフラを支えています。',
  },
  fabricationSolutions: {
    heading: '製作ソリューション',
    intro: '当社では、以下をはじめとする多様な産業機器の製作を行っています。',
    cards: {
      vessels: { title: '圧力容器', desc: '反応器、タンク、塔、熱交換器。' },
      piping: { title: '配管プレファブリケーション', desc: '石油化学・製薬プラントへの効率的な設置に対応します。' },
      heating: { title: '産業用加熱設備', desc: 'マッフル、ラジアントチューブ、ロータリーキルン、トレイ、バスケット。' },
      etc: { title: 'その他', desc: 'あらゆる製作設備。' },
    },
  },
  maintenance: {
    heading: 'メンテナンス・修繕',
    description:
      '新規製作に加えて、機器の寿命と性能を延ばすため、自社工場および客先現地の両方でメンテナンス・修繕サービスを提供しています。',
    buttons: {
      retubing: '熱交換器のリチューブ',
      pipelineRepairs: '配管の修理・保守',
      onSiteMaintenance: '現地・工場でのメンテナンス',
      etc: 'その他',
    },
  },
};
